export const INTERVENTION_JOB_MODULES_MODEL_KEYS = {
  LIST: "interventions.jobModules" as const,
};
